import React from "react";
import { observer, inject } from "mobx-react";
import { SelectField } from "ComponentsUI/Selectfield";
import SortPanel from "../Containers/SortPanel";
import { generateUrl } from "Services/withDefaultParams";
import Routes from "Configs/routes";
import FiltersLoadParams from "HOC/FiltersLoadParams";
import queryString from "query-string";
//import Metrika from "Services/Metrika";
//import { EVENT_CATEGORY_SORT_DATA } from "Constants/metriks/GoogleCategorys";
import { withRouter } from "react-router-dom";

@inject("ApplicationModel")
@observer
class SortContainer extends FiltersLoadParams {
	constructor(props) {
		super(props);
		let text = props.ApplicationModel.text;
		this.state = {
			sort: [
				{
					id: 1,
					key: "-is_exclusive",
					name: text.SORT_BY_POP_1,
					down: true,
				},
				{
					id: 2,
					key: "-displayPrice",
					name: text.SORT_BY_PRICE_1,
					up: true,
				},
				{
					id: 3,
					key: "displayPrice",
					name: text.SORT_BY_PRICE_2,
					down: true,
				},
				{
					id: 4,
					key: "name",
					name: text.SORT_BY_NAME_1,
					down: true,
				},
				{
					id: 5,
					key: "-name",
					name: text.SORT_BY_NAME_2,
					up: true,
				},
			],
			requireUpdate: false,
		};
		this.initAggregateForPopup = !this.props.initAgrregationForPopup;
	}

	componentDidUpdate() {
		if (!this.initAggregateForPopup) {
			if (!!this.props.initAggregation) {
				!!this.props.initAgrregationForPopup &&
					this.props.initAgrregationForPopup(this.props.initAggregation);
				this.initAggregateForPopup = true;
			}
		}
	}

	onSort(sort) {
		const {
			location: { search },
			history,
		} = this.props;

		const getParams = queryString.parse(search);

		let urlArr = [];

		let activeSort = sort[0];

		if (!!activeSort.key) {
			getParams.sort = activeSort.key;
		} else {
			delete getParams.sort;
		}

		for (let key in getParams) {
			if (getParams[key]) {
				urlArr.push(`${key}=${getParams[key]}`);
			}
		}

		let routesMobileUrl;
		if (this.props.match.path === "/:regionUrl?/operatory/:operator/actions") {
			routesMobileUrl = generateUrl(Routes.OperatoryActions.route, {
				regionUrl: this.props.match.params.regionUrl,
				operator: this.props.match.params.operator,
				tagCode: this.props.match.params.tagCode,
			});
		} else {
			routesMobileUrl = generateUrl(Routes.OperatoryTariffs.route, {
				regionUrl: this.props.match.params.regionUrl,
				operator: this.props.match.params.operator,
				tagCode: this.props.match.params.tagCode,
			});
		}

		//  Metrika.getInstance().google.sendEvent(
		//      EVENT_CATEGORY_SORT_DATA,
		//      `sort_data.tariffs.${urlArr.join("&")}`
		//  );

		history.push({
			pathname: routesMobileUrl,
			search: `?${urlArr.join("&")}`,
		});
	}

	componentWillUnmount() {
		let { ApplicationModel } = this.props;
		ApplicationModel.setRatesFromMainPage(false);
	}

	render() {
		let {
			ApplicationModel: { text },
		} = this.props;

		let sortFinded = this.getSortFromParams(this.state.sort);

		let windowSizes = this.props.ApplicationModel.windowSizeModel.windowSizes;

		let sort = (
			<SelectField
				multiselect={false}
				windowSizes={windowSizes}
				items={this.state.sort}
				onItemSelect={(items) => this.onSort(items)}
				text={text}
				findItems={sortFinded}
				placeholder={text.SORT_BY}
				activePlaceHolder={text.SORT_BY}
				onlyInputDisabled={true}
				withoutClose={true}
				whiteInput={true}
				inputName="sort_tariffs"
			/>
		);

		return <SortPanel text={text} sort={sort} />;
	}
}

export default withRouter(SortContainer);
